module.exports = __webpack_public_path__ + "img/1489739586.e6d246ae.jpg";